import React, { Component } from 'react';
import '../assets/css/feedback.css';
import { SEND } from "../utilities/const";
import close from "../assets/img/close.png"
import { bindActionCreators } from "redux";
import { postFeedback } from "../actions";
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';

class Feedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            complain: '',
        }
    }

    // handleComplain = text => {
    //     this.setState()
    // }

    render() {
        if (this.props.show) {
            return (<div id="backdrop">
                <div>
                    <img src={close} onClick={
                        this.props.closeFeedback
                    } />
                    <form>
                        <textarea rows="4" cols="50" placeholder="Отправить сообщение" value={this.state.complain}
                            onChange={text => this.setState({ complain: text.target.value })} />
                        
                        <div class="submit-btn">
                        <Button variant="contained" color="primary" >
                        <input type="submit" value={SEND} onClick={e => {
                            e.preventDefault();
                            let data = {
                                id: this.props.itemId,
                                url: window.location.href,
                                text: this.state.complain
                            };
                            this.props.postFeedback(data);
                            this.props.closeFeedback();
                        }}/>
                        </Button>

                        </div>

                    </form>
                </div>
            </div>)
        }
        return null;
    }
}

function dispatchToProps(dispatch) {
    return bindActionCreators({
        postFeedback: postFeedback,
    }, dispatch);
}

export default connect(null, dispatchToProps)(Feedback);



// WEBPACK FOOTER //
// ./src/components/Feedback.js